import { CmsMeta } from '../cmsMeta';
import { ReactNode } from 'react';
import './CmsStack.css';

type CmsStackParams = {
	children: ReactNode;
	horizontal?: boolean;
	gap?: 'lg' | 'md' | 'sm' | 'xl';
};

export const CmsStack = ({ children, horizontal, gap }: CmsStackParams): JSX.Element => {
	const classes = ['stack'];
	if (horizontal) classes.push('horizontal');
	if (gap) classes.push(`gap-${gap}`);

	return <div className={classes.join(' ')}>{children}</div>;
};

export const cmsMeta: CmsMeta = {
	description: 'Stacks its children with even spacing, vertically by default or side by side when horizontal is set.',
	example: [
		'CmsStack',
		{ gap: 'md' },
		['CmsHtml', { content: '<p>Erst</p>' }],
		['CmsHtml', { content: '<p>Dann</p>' }],
	],
};
